import s from "./additionalComment.module.css";
import {nadWhiteArrow} from "../../../../../assets";
import {useAppContext} from "../../../../../contexts";

const AdditionalComment = (props) => {
    // Destructured props
    const {
        formValues,
        handleChange
    } = props;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    return (
        <div className={`flex flex-col items-start w-full gap-y-4 overflow-hidden ${typeof formValues.fsRating === "number" ? s.animation : "max-h-0"}`}>
            <h2 className={`${s.heading} ${highContrast ? "!text-white" : ""}`}>
                Antes de finalizar a pesquisa, deixe um elogio ou sugestão para a nossa Loja Virtual.
            </h2>
            <textarea
                name="additionalComment"
                value={formValues.additionalComment}
                placeholder={"Digite aqui"}
                className={s.textArea}
                onInput={e => handleChange(e)}
            />
            <button
                type={"submit"}
                id={"fifth-step-submit-button"}
                className={`${s.submitButton} ${highContrast ? "highFormButton" : ""}`}
            >
                Prosseguir
                <img
                    src={nadWhiteArrow}
                    alt="White arrow"
                />
            </button>
        </div>
    )
}

export default AdditionalComment;
